import { removeScriptFullDoc } from 'utils/script';
import { isNull } from 'utils/tsHelpers';
import { HTMLTagTypes } from '../domain/html';

const getParsedDocument = (content: string): Document | null => {
  try {
    // IMPORTANT: content must be securely sanitized before being parsed into a Document!
    const sanitizedContent = removeScriptFullDoc(content);
    return new DOMParser().parseFromString(sanitizedContent, 'text/html');
  } catch {
    return null;
  }
};

const getBodyNodesFromDocument = (document: Document | null): NodeListOf<ChildNode> | null =>
  document?.body.childNodes ?? null;

const isImageTagNode = (node: ChildNode): node is HTMLImageElement =>
  node.nodeName === HTMLTagTypes.Image;

export const getHtmlImageTagSrc = (content: string) => {
  // IMPORTANT: NEVER attach `parsedDocument` or its nodes to `window` as they contain untrusted HTML
  const parsedDocument = getParsedDocument(content);
  const bodyNodes = getBodyNodesFromDocument(parsedDocument);

  // Exit early if content is more than just a single block
  if (bodyNodes?.length !== 1) return null;
  const element = bodyNodes.item(0);

  return isImageTagNode(element) ? element.src : null;
};

export const isHtmlImageTag = (content: string) => !isNull(getHtmlImageTagSrc(content));
